module.exports = __webpack_public_path__ + "img/OPASS-pass-stamp.adfe341d.png";